const InterestGroups = [
  {
    id: "autocad",
    interestgroup: "AutoCAD",
    comingsoon: false,
    interestgroupdescription:
      "AutoCAD is a computer-aided design (CAD) software application developed and marketed by Autodesk. It is used for creating 2D and 3D designs, both in architectural and mechanical fields. It is widely used across a variety of industries, including architecture, engineering, construction, and manufacturing. AutoCAD is known for its precise and accurate designs and its ability to easily create and edit drawings. Additionally, it offers a wide range of tools and features that allow users to create highly detailed and complex designs with ease.",
    leads: [
      {
        id: 1,
        name: "Abhijith E S",
        college: "St. Joseph's College of Engineering and Technology, Palai",
        images: "/assets/interestGroups/AbhijithES.webp",
      },
    ],
    keywords: [
      {
        id: "1",
        keyword: "AutoCad",
      },
      {
        id: "2",
        keyword: "AutoDesk",
      },
      {
        id: "3",
        keyword: "Civil Engineering",
      },
      {
        id: "4",
        keyword: "Drafting",
      },
      {
        id: "5",
        keyword: "Designing",
      },
      {
        id: "6",
        keyword: "CAD",
      },
      {
        id: "7",
        keyword: "CAD Engineer",
      },
    ],
    opportunities: ["Drafter", "Designer", "Quantity Surveyor"],
    officetime: "Wednesday 7:00 PM",
    officeplace: " @ Discord Lobby",
    pagination: [
      {
        id: "innovation",
        name: "< Innovation",
      },
      {
        id: "web",
        name: "Web Development >",
      },
    ],
    mentorscard: [],
    corecourses: [
      {
        id: "2",
        name: "Autocad - Complete Course for Beginners",
        link: "/civil/autocad/core/1",
        time: "",
        complexity: "",
        karma: "100",
      },
      {
        id: "3",
        name: "Autocad - Floor Plan + Elevation",
        link: "/civil/autocad/core/2",
        time: "",
        complexity: "",
        karma: "100",
      },
      {
        id: "4",
        name: "Autocad - Exercises",
        link: "/civil/autocad/core/3",
        time: "",
        complexity: "",
        karma: "100",
      },
    ],
    learningpaths: [
      {
        name: "Technical Drawing for Design and Drafting",
        link: "https://www.autodesk.com/certification/learn/course/course-v1:autodesk+autocad-drawing-design-drafting-professional+2020",
      },
      {
        name: "Drawing Management for Design and Drafting",
        link: "https://www.autodesk.com/certification/learn/course/course-v1:autodesk+autocad-drawing-management-professional+2020",
      },
      {
        name: "Annotating and Dimensioning for Design and Drafting",
        link: "https://www.autodesk.com/certification/learn/course/course-v1:autodesk+autocad-annotating-dimensioning-professional+2020",
      },
      {
        name: "Creating and Modifying Objects with Accuracy for Design and Drafting",
        link: "https://www.autodesk.com/certification/learn/course/course-v1:autodesk+autocad-objects-design-drafting-professional+2021",
      },
      {
        name: "Layout and Output Drawings for Design and Drafting",
        link: "https://www.autodesk.com/certification/learn/course/course-v1:autodesk+autocad-layout-output-design-drafting-professional+2021",
      },
    ],
  },
  {
    id: "revit",
    comingsoon: false,
    interestgroup: "Revit",
    interestgroupdescription:
      "Autodesk's Revit is a well-known Building Information Modeling (BIM) programme. It is commonly used to produce intricate 3D models of buildings and other structures in the design, engineering, and construction industries.",
    leads: [
      {
        id: 1,
        name: "Abhijith E S",
        college: "St. Joseph's College of Engineering and Technology, Palai",
        images: "/assets/interestGroups/AbhijithES.webp",
      },
    ],
    officetime: "Wednesday 7:00 PM",
    officeplace: " @ Discord Lobby",
    pagination: [],
    mentorscard: [],
    corecourses: [
      {
        id: "1",
        name: "Revit - Complete Tutorials",
        link: "/civil/revit/core/1",
        time: "",
        complexity: "#cl-rv-planhome",
        karma: "200",
      },
      {
        id: "1",
        name: "Exercise to Model a House",
        link: "/civil/revit/core/2",
        time: "",
        complexity: "#cl-rv-modelhome",
        karma: "400",
      }
    ],
    learningpathst: [
      {
        track: "Architectural Design",
        name: "Introduction to 3D Modeling for Architectural Design",
        link: "https://www.autodesk.com/certification/learn/course/revit-3d-modeling-architectural-design-professional",
      },
      {
        track: "Architectural Design",
        name: "Advanced 3D Modeling for Architectural Design",
        link: "https://www.autodesk.com/certification/learn/course/revit-advanced-3d-modeling-architecture-professional",
      },
      {
        track: "Architectural Design",
        name: "Families and Parameters for Architectural Design",
        link: "https://www.autodesk.com/certification/learn/course/families-and-parameters-architectural-design-professional",
      },
      {
        track: "Architectural Design",
        name: "Managing Projects Using Revit",
        link: "https://www.autodesk.com/certification/learn/course/revit-managing-projects-professional",
      },
      {
        track: "Architectural Design",
        name: "Documentation and Publishing for Architectural Design",
        link: "https://www.autodesk.com/certification/learn/course/revit-documentation-architectural-design-professional",
      },
      {
        track: "Structural Design",
        name: "Families and Parameters for Structural Design",
        link: "https://www.autodesk.com/certification/learn/course/revit-families-parameters-structure-professional",
      },
      {
        track: "Structural Design",
        name: "3D Modeling Foundations and Substructure",
        link: "https://www.autodesk.com/certification/learn/course/revit-3d-modeling-structure-professional",
      },
      // {
      //   track: "Electrical Design",
      //   name: "Modeling and System Design Techniques for Electrical Design",
      //   link: "https://www.autodesk.com/certification/learn/course/revit-electrical-modeling-system-design-professional",
      // },
      // {
      //   track: "Mechanical Design",
      //   name: "Modeling and System Design Techniques for Mechanical Design",
      //   link: "https://www.autodesk.com/certification/learn/course/revit-mechanical-modeling-system-design-professional",
      // },
      // {
      //   track: "Mechanical Design",
      //   name: "Systems Analysis for Mechanical Design Using Revit",
      //   link: "https://www.autodesk.com/certification/learn/course/revit-system-analysis-mechanical-design-professional",
      // },
    ],
  }
]

export default InterestGroups
